// INFO:
// ----------------------------------------------------------------
// 		- Kvůli podpoře IE prosím NEPOUŽÍVAT arrow functions.
// ----------------------------------------------------------------

/** Zajistuje zobrazeni a schovani #searchWrap po kliknuti na ikonku lupy pro Internet Explorer. */
searchWrapToggleIE = function () {
	const searchIcon = document.querySelector('.searchIcon a');
	const searchWrap = document.querySelector('#search-wrap');
	let isSlideOpen = false;

	searchIcon.addEventListener('click', function (e) {
		e.preventDefault ? e.preventDefault() : e.returnValue = false;



		if( ! isSlideOpen) {
			searchWrap.style.display = 'block';
			isSlideOpen = true;
		}
		else {
			searchWrap.style.display = 'none';
			isSlideOpen = false;
		}
	});
}

/** Zajistuje slizdeni a zajizdeni #searchWrap po kliknuti na ikonku lupy. */
searchWrapSlideToggle = function () {
	const searchIcon = document.querySelector('.searchIcon a');
	const searchWrap = document.querySelector('#search-wrap');

	searchIcon.addEventListener('click', function (e) {
		e.preventDefault();

		let isSlideOpen = searchWrap.classList.contains('active');

		if( ! isSlideOpen) {
			// Zobrazí(slideDown) searchWrap.
			searchWrap.classList.add('active');
			searchWrap.style.height = 'auto';

			// Získání spočítané výšky pro searchWrap.
			let height = searchWrap.clientHeight;

			// Nastavení výšky searchWrapu na 0px abychom mohli animovat zobrazeni(slide down).
			searchWrap.style.height = '0px';

			// Po tom co jsme nastavili výšku na 0px, nastavime požadovanou výšku, čímž spustíme animaci.
			// SetTimeout pushne task do stacku. Což ve výsledku znamená, že proces proběhne PO synchroních procesech. */
			setTimeout(function () {
				searchWrap.style.height = height + 'px';
			}, 0);
		}
		else {
			// Nastavení výšky searchWrapu na 0px čímž spustíme animaci(slide up).
			searchWrap.style.height = '0px';

			// Odebrání třídy .active až animace skončí.
			searchWrap.addEventListener(
				'transitionend',
				function () { searchWrap.classList.remove('active') },
				{once: true}
			);
		}
	});
}

/** Zabrani odeslani pokud je search bar prazdny, nebo obsahuje jenom bile znaky. */
preventSendingEmptySearchBar = function () {
	document.querySelector('#search-wrap form.search-form')
		.addEventListener('submit', function (event) {
			const searchBarElement  = event.target.querySelector('div.search-bar input[type="text"][name="q"]');

			if( searchBarElement.value.trim() === '' )
				event.preventDefault();
		});
}

const isInternetExplorer = (
	window.navigator.userAgent.indexOf('MSIE') > -1 ||
	window.navigator.userAgent.indexOf('Trident') > -1
);

if( isInternetExplorer )
	window.addEventListener("load", searchWrapToggleIE, false);
else
	window.addEventListener("load", searchWrapSlideToggle, false);

window.addEventListener("load", preventSendingEmptySearchBar, false);
